import React from 'react';
import { Alert, Title, Close } from '@zendeskgarden/react-notifications';

interface RepairAlertProps {
  message: string;
  onClose: () => void;
  type?: 'success' | 'error' | 'warning' | 'info';
}

const RepairAlert: React.FC<RepairAlertProps> = ({ message, onClose, type = 'success' }) => (
    <Alert type={type} style={{ width: '70%', boxSizing: 'border-box', marginBottom: '12px' }}>
        <Title>{type.charAt(0).toUpperCase() + type.slice(1)}</Title>
        {message}
        <Close aria-label={`Close ${type.charAt(0).toUpperCase() + type.slice(1)} Alert`} onClick={onClose} />
    </Alert>
);

export default RepairAlert; 